import React from 'react';
import { X } from 'lucide-react';
import { Dialog, DialogContent } from './ui/dialog';

const VideoPlayer = ({ videoKey, title, onClose }) => {
  if (!videoKey) return null;

  return (
    <Dialog open={!!videoKey} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl w-full p-0 bg-black border-none">
        <div className="relative pt-[56.25%]">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-50 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors"
          >
            <X size={24} />
          </button>
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${videoKey}?autoplay=1&modestbranding=1&rel=0`}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VideoPlayer;
